import { render, staticRenderFns } from "./LastMileModule.vue?vue&type=template&id=dc8db63e&scoped=true"
import script from "./LastMileModule.vue?vue&type=script&lang=js"
export * from "./LastMileModule.vue?vue&type=script&lang=js"
import style0 from "./LastMileModule.vue?vue&type=style&index=0&id=dc8db63e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8db63e",
  null
  
)

export default component.exports